export const environment = {
  production: false,
  api_url: 'https://apikong.dev.credimovil.pe/po-ms-management/v1',
  base_url_websocket: 'https://apikong.dev.credimovil.pe',
  useHash: false,
  redirectHome: 'https://dev.credimovil.pe/',
  redirecComplaints: 'https://reclamos.dev.credimovil.pe/',
};
